import NamedDto from 'modules/base/dto/NamedDto';

import OptimizationPipelinePiMeasurementEntryDto from './OptimizationPipelinePiMeasurementEntryDto';
import OptimizationPipelineLabMeasurementEntryDto from './OptimizationPipelineLabMeasurementEntryDto';

export class OptimizationPipelineEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {number} */
		this.mergedMeasurement = null;

		/** @type {number} */
		this.cleanMeasurement = null;

		/** @type {number} */
		this.modelValidation = null;

		/** @type {number} */
		this.unitOptimizer = null;

		/** @type {number} */
		this.optimizationPipelineLog = null;

		/** @type {number} */
		this.edtDynamicCheck = null;

		/** @type {number} */
		this.piWriter = null;

		/** @type {number} */
		this.opcDaWriter = null;

		/** @type {number[]} */
		this.outlierDetectors = null;

		/** @type {OptimizationPipelinePiMeasurementEntryDto[]} */
		this.piMeasurementEntries = null;

		/** @type {OptimizationPipelineLabMeasurementEntryDto[]} */
		this.labMeasurementEntries = null;

		/** @type {number} */
		this.userGroup = null;

		/** @type {number} */
		this.summaryDuration = null;

		/** @type {string} */
		this.summaryDurationUnit = null;

		/** @type {string} */
		this.summaryType = null;
	}

	/**
	 * @typedef {Object} _OptimizationPipelineEditDtoProps
	 * @property {number} mergedMeasurement
	 * @property {number} cleanMeasurement
	 * @property {number} modelValidation
	 * @property {number} unitOptimizer
	 * @property {number} optimizationPipelineLog
	 * @property {number} edtDynamicCheck
	 * @property {number} piWriter
	 * @property {number} opcDaWriter
	 * @property {number[]} outlierDetectors
	 * @property {OptimizationPipelinePiMeasurementEntryDto[]} piMeasurementEntries
	 * @property {OptimizationPipelineLabMeasurementEntryDto[]} labMeasurementEntries
	 * @property {number} userGroup
	 * @property {number} summaryDuration
	 * @property {string} summaryDurationUnit
	 * @property {string} summaryType
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OptimizationPipelineEditDtoProps} OptimizationPipelineEditDtoProps
	 */

	/**
	 *
	 * @param {OptimizationPipelineEditDtoProps} props
	 * @returns {OptimizationPipelineEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.mergedMeasurement = props.mergedMeasurement;
		this.cleanMeasurement = props.cleanMeasurement;
		this.modelValidation = props.modelValidation;
		this.unitOptimizer = props.unitOptimizer;
		this.optimizationPipelineLog = props.optimizationPipelineLog;
		this.edtDynamicCheck = props.edtDynamicCheck;
		this.piWriter = props.piWriter;
		this.opcDaWriter = props.opcDaWriter;
		this.outlierDetectors = props.outlierDetectors !== null ? props.outlierDetectors : [];
		this.piMeasurementEntries = props.piMeasurementEntries !== null ? props.piMeasurementEntries.map(d => new OptimizationPipelinePiMeasurementEntryDto().setup(d)) : [];
		this.labMeasurementEntries = props.labMeasurementEntries !== null ? props.labMeasurementEntries.map(d => new OptimizationPipelineLabMeasurementEntryDto().setup(d)) : [];
		this.userGroup = props.userGroup;
		this.summaryDuration = props.summaryDuration;
		this.summaryDurationUnit = props.summaryDurationUnit;
		this.summaryType = props.summaryType;

		return this;
	}
}

export default OptimizationPipelineEditDto;